import { common } from '@ocean/ui'
import { Label } from './CardLabel.styled'

const { Typography } = common

type CardLabelProps = {
  title: string
}

const CardLabel: React.FC<CardLabelProps> = ({ title }) => {
  return (
    <Label>
      <Typography variant='h4' color='white' uppercase dataTest='CardLabel'>
        {title}
      </Typography>
    </Label>
  )
}

export default CardLabel
